import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif",
    h1: {
      fontSize: 50,
      fontWeight: 900,
    },
  },
  palette: {
    type: "light",
    primary: {
      main: window.THEME.primary,
    },
    secondary: {
      main: window.THEME.secondary,
    },
    error: {
      main: window.THEME.error,
    },
    warning: {
      main: window.THEME.warning,
    },
    orange: {
      main: "#FF5F1F",
    },
    blue: {
      main: "#00bfff",
    },
    messageText: {
      main: "#3c4b64",
    },
    background: {
      paper: "#fff",
    },
    device: {
      main: "#9ABAED",
      contrastText: "#fff",
    },
    group_and_district: {
      main: "#506FA1",
      contrastText: "#fff",
    },
    network: {
      main: "#3c4b64",
      contrastText: "#fff",
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#2c3e50",
          color: "#fff",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeader: {
          fontSize: "12px",
        },
        cell: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 50,
        },
      },
    },
  },
});

export default theme;
